import axios from "axios";
import { startMixPanel } from "@/utils/mixpanel";
// import { useAuth0 } from '@auth0/auth0-vue';

const INITIAL_STATE = {
  id: undefined,
  name: "",
  hashId: "",
  preferredName: "",
  type: "",
  userType: "",
  auth0Id: "",
  auth0IdPrefixed: "",
  email: { email: undefined },
  country: "",
  organization: "",
  loading: false,
  hasCompletedHomepageTour: false,
  hasCompletedScheduleTour: false,
  hasCompletedExperienceTour: false,
  hasCompletedGPCRHomepageTour: false,
  hasCompletedGPCRScheduleTour: false,
  hasCompletedGPCRExperienceTour: false,
  signupCheck: true,
  needLiveVoice: false,
  fcmToken: "",
  channels: [],
  confYear: "",
};

const state = () => INITIAL_STATE;

const mutations = {
  setProfileState(state, newProfile) {
    for (const key in newProfile) state[key] = newProfile[key];
  },
  setLoading(state, isLoading) {
    state.loading = isLoading;
  },
};

const actions = {
  async fetchProfile({ dispatch, state }) {
    // Will not call backend api if profile already set
    if (state.name) {
      return;
    }
    await dispatch("forceFetchProfile");
  },

  async forceFetchProfile({ commit, dispatch, rootState }) {
    // for tracking false - hide email, organization
    commit("setLoading", true);
    try {
      const accessToken = rootState.user.token;
      const { status, data } = await axios.get(
        process.env.VUE_APP_API_URL + "/profile",
        {
          headers: {
            Authorization: `Bearer ${accessToken}`,
          },
        }
      );
      if (status !== 200) throw new Error("Failed in setting profile");
      commit("setProfileState", data);

      const userProps = {
        delegateName: data.name,
        teamID: data.groupName,
        // year: data.confYear.split("-")[0],
        userType: data.userType,
        delegateType:
          data.organization === "Heart of God Church" ? "Host" : "Delegate",
      };

      if (data.tracking) {
        userProps.delegateEmail = data.email;
        userProps.churchName = data.organization;
      }

      const windowDataLayer = {
        event: "login",
        user_id: data.id,
        gicUserid: data.id,
        userType: data.type,
        ...userProps,
      };

      if (data.tracking) {
        windowDataLayer.userOrganization = data.organization;
        windowDataLayer.userEmail = data.email;
      }
      window.dataLayer.push(windowDataLayer);
      gtag('set', 'user_properties', windowDataLayer);
      console.log("gtag set user properties")

      startMixPanel(data.id, data.email, data.name, data.organization, data.groupName);

    } catch (e) {
      dispatch("toast/error", "Failed to load profile.", { root: true });
    } finally {
      commit("setLoading", false);
    }
  },
}

const getters = {
  id: state => state.id,
  name: state => state.name,
  email: state => state.email,
  country: state => state.country,
  organization: state => state.organization
};


export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
